import React from 'react'
import PropTypes from 'prop-types'
import { Container, Row, Col } from 'reactstrap'
import { withStyles } from '@material-ui/core/styles'
import { Grid, Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, Paper } from '@material-ui/core'
import DayPicker from 'react-day-picker'
import Moment from 'react-moment'
import CircularProgress from '@material-ui/core/CircularProgress'
import Cancel from '@material-ui/icons/Cancel'
import moment from 'moment'

import DateHelpers from '../../classes/DateHelpers'
import Searchbar from './searchbar/Searchbar'
import MultiSelectDropDown from './dropdown/MultiSelectDropDown'
import './CalendarComponent.scss'
import { ENGAGEMENTS, GENRE, NETWORK, TYPE } from '../../constants/commons'
import CalendarOnBoarding from './CalendarOnboarding'

export default class CalendarComponent extends React.Component {
  static propTypes = {
    calendar: PropTypes.object.isRequired,
    history: PropTypes.object,
    params: PropTypes.object,
    calendarExport: PropTypes.func,
    calendarExportIsFetching: PropTypes.shape({
      isFetching: PropTypes.bool.isRequired,
      error: PropTypes.object
    }).isRequired,
    shortcut: PropTypes.shape({
      id: PropTypes.string.isRequired,
      expires_at: PropTypes.string.isRequired,
      target: PropTypes.string.isRequired,
      target_id: PropTypes.string
    })
  }

  constructor (props) {
    super(props)

    this.state = {
      selectedDay: null,
      types: [],
      categories: [],
      genres: [],
      engagements: [
        { name: '<100', value: '<100' },
        { name: '100 - 1k', value: '101 to 1,000' },
        { name: '1k - 10k', value: '1,001 to 10,000' },
        { name: '10k - 100k', value: '10,001 to 100,000' },
        { name: '>100k', value: '100,001+' }
      ],
      selectedTypes: [],
      selectedNetworks: [],
      selectedGenres: [],
      selectedEngagements: [],
      searchText: '',
      dateTo: null,
      selectedModule: '',
      isOpen: false,
      exportCompleted: false,
      tourFinished: false,
      hideShortcutBanner: false
    }
  }
  componentDidMount () {
    if (this.props.calendar && this.props.calendar.details) {
      this.setCalendarData()
    }
    if (this.props.shortcut) {
      let selectedDay = moment().format('MM/DD/YYYY')
      if (document.getElementById(selectedDay)) {
        document.getElementsByClassName('calendarTable')[0].scrollTo({ top: 0, behavior: 'smooth' })
      }
    }
  }

  componentDidUpdate (prevProps, prevState) {
    let month = !this.props.shortcut && this.props.params.month
    let day = !this.props.shortcut && this.props.params.day
    let year = !this.props.shortcut && this.props.params.year
    let selectedDay = !this.props.shortcut ? `${month}/${day}/${year}` : DateHelpers.getDateString(this.state.selectedDay ? this.state.selectedDay : new Date())
    if ((!this.props.shortcut && !prevState.selectedDay && !this.state.selectedDay && document.getElementById(selectedDay)) || (!this.props.shortcut && prevState.selectedDay !== this.state.selectedDay) || (!this.props.shortcut && prevProps.params !== this.props.params) || (this.props.shortcut && this.state.tourFinished) || (this.props.shortcut && prevState.selectedDay !== this.state.selectedDay)) {
      if (document.getElementById(selectedDay)) {
        document.getElementsByClassName('calendarTable')[0].scrollTo({ top: document.getElementById(selectedDay).offsetTop - 85, behavior: 'smooth' })
      }
    }
    if (prevProps.calendar !== this.props.calendar && this.props.calendar && this.props.calendar.details) {
      this.setCalendarData()
    }
    if (this.props.calendarExportIsFetching && !this.props.calendarExportIsFetching.isFetching && prevProps.calendarExportIsFetching.isFetching!=this.props.calendarExportIsFetching.isFetching) {
      this.setState({ exportCompleted: true })
      setTimeout(() => {
        this.setState({ exportCompleted: false })
      }, 3000)
    }
  }

  setCalendarData = () => {
    const details = this.props.calendar.details
    const dateArr = DateHelpers.getDaysArray()
    let types = []
    let categories = []
    let genres = []
    dateArr.map(date => {
      const detail = details[date]
      if (detail) {
        detail.map(d => {
          types.push(d.entity_type)
          d.channel && d.channel.map(c => categories.push(c))
          d.genre && d.genre.map(g => genres.push(g))
        })
      }
    })
    let typeList = types.reduce(function (a, b){
      if (a.indexOf(b) < 0 ) a.push(b)
      return a
    }, [])
    typeList = typeList.sort((a, b) => (a < b) ? -1 : (a > b) ? 1 : 0)
    let categoryList = categories.reduce(function (a, b){
      if (a.indexOf(b) < 0 ) a.push(b)
      return a
    }, [])
    categoryList = categoryList.sort((a, b) => (a < b) ? -1 : (a > b) ? 1 : 0)
    let genreList = genres.reduce(function (a, b){
      if (a.indexOf(b) < 0 ) a.push(b)
      return a
    }, [])
    genreList = genreList.sort((a, b) => (a < b) ? -1 : (a > b) ? 1 : 0)
    this.setState({
      types: typeList,
      categories: categoryList,
      genres: genreList,
      dateTo: new Date(dateArr[dateArr.length - 2])
    })
  }

  handleDayClick = day => {
    const dateString = DateHelpers.getDateString(day)
    this.setState({ selectedDay: day, selectedModule: '', isOpen: false })
    !this.props.shortcut && this.props.history.push(`/insights/calendar/${dateString}`)
  }
  handleTypes = (types) => {
    this.setState({ selectedTypes: types, selectedModule: TYPE, isOpen: true })
  }
  handleNetworks = (networks) => {
    this.setState({ selectedNetworks: networks, selectedModule: NETWORK, isOpen: true })
  }
  handleGenres = (genres) => {
    this.setState({ selectedGenres: genres, selectedModule: GENRE, isOpen: true })
  }
  handleEngagements = (engagements) => {
    this.setState({ selectedEngagements: engagements, selectedModule: ENGAGEMENTS, isOpen: true })
  }
  clearFilters = () => {
    this.setState({
      selectedTypes: [],
      selectedNetworks: [],
      selectedGenres: [],
      selectedEngagements: [],
      searchText: '',
      isOpen: false
    })
    this.handleDayClick(new Date())
  }
  searchData = value => {
    this.setState({ searchText: value, isOpen: false })
  }

  _renderShortcut () {
    if (!this.props.shortcut || this.state.hideShortcutBanner) {
      return null
    }

    const expires = this.props.shortcut.expires_at
    const click = e => {
      e.preventDefault()
      this.setState({ hideShortcutBanner: true })
    }

    return (
      <div className='shortCutBanner'>
        <span>
          <span>This preview of <strong>Calendar</strong> will expire on&nbsp;</span>
          <Moment format='MM/DD/YYYY'>{expires}</Moment>
        </span>
        <span onClick={click}><Cancel /></span>
      </div>
    )
  }

  handleTourCallBack = () => {
    this.setState({tourFinished: true})
  }
  _renderOnboarding () {
    if (!this.props.shortcut) {
      return null
    }

    return (
      <CalendarOnBoarding
        name={'Calendar'}
        run={true}
        handleTourCallBack={this.handleTourCallBack}
      />
    )
  }

  render () {
    const details = this.props.calendar && this.props.calendar.details
    const dateArr = DateHelpers.getDaysArray()
    const StyledTableCell = withStyles(() => ({
        head: {
          background: '#F4F5F6',
          height: 48,
          color: '#808184'
        }
      }))(TableCell)

    return (
      <div className="rightSide calendarComponent">
        <Container fluid={true}>
          {this._renderShortcut()}
          {this._renderOnboarding()}
          <Row className="header calendarHeader">
            <Col>
              <ul className="hFirstRow">
                <li className="imgHolder">
                  <img alt="" src="/static/images/date.png" className="imgThumb" />
                </li>
                <li>
                  <h2 className="title">Calendar</h2>
                </li>
              </ul>
            </Col>
            <Col className="exportCal">
              <Box onClick={this.props.calendarExport} className={`${this.state.exportCompleted ?'export-completed' : `${this.props.calendarExportIsFetching && this.props.calendarExportIsFetching.isFetching ? 'export-icon-fetching' : 'export-icon'}`} topRightActions`}>
                {this.props?.calendarExportIsFetching?.isFetching && <CircularProgress/> }
              </Box>
            </Col>
          </Row>
          <Row>
            <Col className="dateCol">
              { this.state.dateTo &&
                <Box className="dateTxt">
                  <Typography>Schedule through <Moment format="MMM DD, YYYY">{this.state.dateTo}</Moment></Typography>
                </Box>
              }
            </Col>
          </Row>
          <Row>
            <Col>
              <Box className="calendarWrapper">
                <Grid container className="mdFlip">
                  <Grid item lg={9} md={12} sm={12} xs={12}>
                    <Paper className="calanderCard">
                      <TableContainer className="calendarTable">
                        <Table stickyHeader>
                          <TableHead>
                            <TableRow id='calendarHeader'>
                              <StyledTableCell className='dateHeader'>Date</StyledTableCell>
                              <StyledTableCell>
                                <span className='clearFilter'>
                                  <Searchbar listData={this.searchData} exvalue={this.state.searchText}/>
                                  <button className='clearFilterButton' onClick={this.clearFilters}>Clear Filters</button>
                                </span>
                              </StyledTableCell>
                              <StyledTableCell>
                                <MultiSelectDropDown
                                  module={TYPE}
                                  data={this.state.types}
                                  selectedValues={this.state.selectedTypes}
                                  handleSelect={this.handleTypes}
                                  isOpen={this.state.selectedModule === TYPE ? this.state.isOpen : false}
                                  tourFinished={this.state.tourFinished}
                                />
                              </StyledTableCell>
                              <StyledTableCell>
                                <MultiSelectDropDown
                                  module={NETWORK}
                                  data={this.state.categories}
                                  selectedValues={this.state.selectedNetworks}
                                  handleSelect={this.handleNetworks}
                                  isOpen={this.state.selectedModule === NETWORK ? this.state.isOpen : false}
                                  tourFinished={this.state.tourFinished}
                                />
                              </StyledTableCell>
                              <StyledTableCell>
                                <MultiSelectDropDown
                                  module={GENRE}
                                  data={this.state.genres}
                                  selectedValues={this.state.selectedGenres}
                                  handleSelect={this.handleGenres}
                                  isOpen={this.state.selectedModule === GENRE ? this.state.isOpen : false}
                                  tourFinished={this.state.tourFinished}
                                />
                              </StyledTableCell>
                              <StyledTableCell>
                                <MultiSelectDropDown
                                  module={ENGAGEMENTS}
                                  data={this.state.engagements.map(e => e.name)}
                                  selectedValues={this.state.selectedEngagements}
                                  handleSelect={this.handleEngagements}
                                  isOpen={this.state.selectedModule === ENGAGEMENTS ? this.state.isOpen : false}
                                  tourFinished={this.state.tourFinished}
                                />
                              </StyledTableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {!details &&
                              <TableRow key='loading'>
                                <TableCell className='loaderCell'></TableCell>
                                <TableCell></TableCell>
                                <TableCell>
                                  <div className='calendarLoader'>
                                    <CircularProgress />
                                  </div>
                                </TableCell>
                                <TableCell></TableCell>
                                <TableCell></TableCell>
                              </TableRow>
                            }
                            {details && dateArr && dateArr.map((thisDay, index) =>
                              <ScrollTr
                                key={`scroll_${index}`}
                                thisDay={thisDay}
                                details={details[thisDay]}
                                selectedDay={this.state.selectedDay}
                                selectedTypes={this.state.selectedTypes}
                                selectedNetworks={this.state.selectedNetworks}
                                selectedGenres={this.state.selectedGenres}
                                selectedEngagements={this.state.selectedEngagements}
                                searchText={this.state.searchText}
                              />
                            )}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </Paper>
                  </Grid>
                  <Grid item lg={3} md={12} sm={12} xs={12}>
                    <Box className="customCalendar">
                      <DayPicker className="card"
                        selectedDays={this.state.selectedDay}
                        onDayClick={this.handleDayClick}
                        initialMonth={new Date()}
                        disabledDays={day => day <= (new Date(dateArr[0])) || day >= (new Date(dateArr[dateArr.length-1]))}
                        showOutsideDays
                        fixedWeeks
                      />
                    </Box>
                  </Grid>
                </Grid>
              </Box>
            </Col>
          </Row>
        </Container>
      </div>
    )
  }
}

export const ScrollTr = ({thisDay, details, selectedTypes, selectedNetworks, selectedGenres, selectedEngagements, searchText}) => {
  const monthLong = new Date(thisDay).toLocaleString('en-us', {month: 'short'})
  const thisDate = new Date(thisDay).toLocaleString('en-us', {day: 'numeric'})
  const isSelectedDay = new Date(thisDay).toDateString() === new Date().toDateString()
  let detail = details && (typeof(searchText) != 'undefined' && searchText.length > 0) ? details.filter(el => { return conforms(searchText, el.display_name, el.name) }) : details
  detail = detail && (typeof(selectedTypes) != 'undefined' && selectedTypes.length > 0) ?
  selectedTypes.flatMap(typeN => detail.filter(t => t.entity_type && t.entity_type === typeN)) : detail
  detail = detail && (typeof(selectedNetworks) != 'undefined' && selectedNetworks.length > 0) ?
  selectedNetworks.flatMap(network => detail.filter(t => t.channel && t.channel.indexOf(network) > -1)) : detail
  detail = detail && (typeof(selectedGenres) != 'undefined' && selectedGenres.length > 0) ?
  selectedGenres.flatMap(genre => detail.filter(t => t.genre && t.genre[0] === genre)) : detail
  detail = detail ? detail.sort((a, b) => b.engagements - a.engagements) : detail
  detail = detail && selectedEngagements.length > 0
  ? detail.filter((item) => {
      return selectedEngagements.some((range) => {
        if (range === '<100') {
          return item.engagements < 100
        } else if (range === '100 - 1k') {
          return item.engagements >= 101 && item.engagements <= 1000
        } else if (range === '1k - 10k') {
          return item.engagements >= 1001 && item.engagements <= 10000
        } else if (range === '10k - 100k') {
          return item.engagements >= 10001 && item.engagements <= 100000
        } else if (range === '>100k') {
          return item.engagements > 100001
        }
        return false
      })
    })
  : detail

  return (
    <>
      { ((!detail || detail.length === 0) && searchText.length === 0 && selectedTypes.length === 0 && selectedNetworks.length === 0 && selectedGenres.length === 0) &&
        <TableRow className="emptyRow" key={`empty_${thisDay}`} id={thisDay}>
          <TableCell>
            <Box className="dateBox">
              <Box className="dateInfo noData">
                <Typography className="tableDay">{thisDate}</Typography>
                <Typography className="tableMonth">{monthLong}</Typography>
              </Box>
              <img src="/static/images/data-norow.png" alt="data-active" className="imgDataRow" />
            </Box>
          </TableCell>
          <TableCell></TableCell>
          <TableCell></TableCell>
          <TableCell></TableCell>
          <TableCell></TableCell>
          <TableCell></TableCell>
        </TableRow>
      }
      { ((detail && searchText.length === 0 && selectedTypes.length === 0 && selectedNetworks.length === 0 && selectedGenres.length === 0) || ((!detail || detail.length === 0) && searchText.length === 0 && selectedTypes.length === 0 && selectedNetworks.length === 0 && selectedGenres.length === 0)) &&
      <TableRow key={`divide_${thisDay}`}>
        <TableCell>
          <Box className="dateBox"></Box>
        </TableCell>
        <TableCell colSpan="5" className="tableTopDivide"></TableCell>
      </TableRow>
      }
      { detail && detail.map((data, index) => (
        <React.Fragment key={`fragment_${index}`}>
          { (index === 0 && (selectedTypes.length > 0 || selectedNetworks.length > 0 || selectedGenres.length > 0 || searchText.length > 0)) &&
          <TableRow key={`divide_${index}`}>
            <TableCell>
              <Box className="dateBox"></Box>
            </TableCell>
            <TableCell colSpan="5" className="tableTopDivide"></TableCell>
          </TableRow>
          }
          <TableRow key={`row_${index}`} id={index === 0 ? thisDay : ''}>
            <TableCell>
              {index === 0 &&
                <Box className="dateBox">
                  <Box className={`${isSelectedDay ? 'dateActive' : ''} dateInfo`}>
                    <Typography className="tableDay">{thisDate}</Typography>
                    <Typography className="tableMonth">{monthLong}</Typography>
                  </Box>
                  {isSelectedDay ?
                    <img src="/static/images/data-active.png" alt="data-active" className="imgRowActive" />
                  :
                    <img src="/static/images/data-row.png" alt="row-with-data" className="imgDataRow" />
                }
                </Box>
              }
              {index > 0 && <Box className="dateBox"></Box>}
            </TableCell>
            <TableCell className="calendarData">{data.display_name || data.name}</TableCell>
            <TableCell>{data.entity_type}</TableCell>
            <TableCell>{data.channel && data.channel.length > 2 ? 'Multiple' : data.channel && data.channel.length === 2 ? data.channel.join().replace(',', ', ') : data.channel ? data.channel : ''}</TableCell>
            <TableCell>{data.genre && data.genre.length > 2 ? 'Multiple' : data.genre && data.genre.length === 2 ? data.genre.join().replace(',', ', ') : data.genre || ''}</TableCell>
            <TableCell>{data.engagements && data.engagements >= 100 ? data.engagements.toLocaleString('en') : 'processing'}</TableCell>
          </TableRow>
        </React.Fragment>
    ))}
    </>
  )
}

ScrollTr.propTypes = {
  thisDay: PropTypes.string,
  selectedDay: PropTypes.object,
  details: PropTypes.array,
  selectedTypes: PropTypes.array,
  selectedNetworks: PropTypes.array,
  selectedGenres: PropTypes.array,
  selectedEngagements: PropTypes.array,
  searchText: PropTypes.string
}

function conforms (searchText, display_name, name) {
  if (containsSpecialChars(searchText)) {
    let res = (typeof(display_name) != 'undefined') ? display_name.toLowerCase().includes(searchText.toLowerCase()) :
        (typeof(name) != 'undefined') ? name.toLowerCase().includes(searchText.toLowerCase()) : false
    return res
  }
  else {
    let filterText = removeSpecCharsAndSpaces(searchText).toLowerCase()
    let res = (typeof(display_name) != 'undefined') ? removeSpecCharsAndSpaces(display_name).toLowerCase().includes(filterText) :
        (typeof(name) != 'undefined') ? removeSpecCharsAndSpaces(name).toLowerCase().includes(filterText) : false
    return res
  }
}

function removeSpecCharsAndSpaces (str) {
  return str.replace(/[^a-z\d\s]+/gi, '').replace(/\s+/g, ' ').trim();
}

function containsSpecialChars (str) {
  const specialChars = /[`!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~]/;
  return specialChars.test(str);
}